import React, { useEffect, useState } from 'react';
import { responsive } from 'constantes';
import { addDot } from '../../utils';
import styled from 'styled-components/macro';
import AnimatedNumber from '../AnimatedNumber';

const c = p => p.replace(',', '.').replace('%', '');

const Row = ({ ...props }) => {
  return <AnimatedNumber {...props} />;
};

const DataTable = ({ data, open }) => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (open) setShow(true);
  }, [open]);

  return show ? (
    <>
      <FirstCol>
        <p>Válidos</p>
        <p className="transparent small">Por candidatos</p>
        <p className="transparent small">En blanco</p>
        <p>No marcados</p>
        <p>Nulos</p>
      </FirstCol>
      <SecondCol>
        <Row value={c(data.totales.act.pvotval)} percentage />
        <Row
          className="transparent small"
          value={c(data.totales.act.pvotcan)}
          percentage
        />
        <Row
          className="transparent small"
          value={c(data.totales.act.pvotbla)}
          percentage
        />
        <Row value={c(data.totales.act.pvotnma)} percentage />
        <Row value={c(data.totales.act.pvotnul)} percentage />
      </SecondCol>
      <ThirdCol>
        <Row value={data.totales.act.votval} formatter={addDot} integer />
        <Row
          className="transparent small"
          value={data.totales.act.votcan}
          formatter={addDot}
          integer
        />
        <Row
          className="transparent small"
          value={data.totales.act.votbla}
          formatter={addDot}
          integer
        />
        <Row value={data.totales.act.votnma} formatter={addDot} integer />
        <Row value={data.totales.act.votnul} formatter={addDot} integer />
      </ThirdCol>
    </>
  ) : null;
};

const FirstCol = styled.div`
  display: grid;
  grid-auto-rows: 1fr;
  font-size: 1.4em;
  line-height: 200%;
  @media screen and (max-width: ${responsive.mobile}px) {
    font-size: 1.2em;
  }
  & > * {
    white-space: nowrap;
  }
  .small {
    margin-left: 1em;
    font-size: 0.8em;
    @media screen and (max-width: ${responsive.mobile}px) {
      font-size: 0.75em;
    }
  }
  .transparent {
    color: #164192b2;
  }
`;

const SecondCol = styled.div`
  display: grid;
  grid-auto-rows: 1fr;
  font-weight: 700;
  font-size: 1.4em;
  line-height: 200%;
  @media screen and (max-width: ${responsive.mobile}px) {
    font-size: 1.2em;
  }
  .small {
    font-size: 0.8em;
    @media screen and (max-width: ${responsive.mobile}px) {
      font-size: 0.75em;
    }
  }
  .transparent {
    color: #164192b2;
  }
  & > * {
    margin-left: auto;
  }
`;
const ThirdCol = styled.div`
  display: grid;
  grid-auto-rows: 1fr;
  font-size: 1.4em;
  line-height: 200%;
  @media screen and (max-width: ${responsive.mobile}px) {
    font-size: 1.2em;
  }
  .small {
    font-size: 0.8em;
    @media screen and (max-width: ${responsive.mobile}px) {
      font-size: 0.75em;
    }
  }
  .transparent {
    color: #164192b2;
  }
  & > * {
    margin-left: auto;
  }
`;

export default DataTable;
